"use strict";

jQuery(function() {
	CC.init();
});


var CC = {
	init: function() {
		this.setEventHandlers();

		this.updateContentWrap();
		this.setZoomLevelFromCookie();
		this.updateZoomButtons();

		this.checkForFormErrors();
 		this.updateFormFields();
	},

	setEventHandlers: function() {
		jQuery('.icon-text-small').on('click', this.zoomOut);
		jQuery('.icon-text-big').on('click', this.zoomIn);

		jQuery('#navbar').find('li').on('shown.bs.dropdown', this.updateContentWrap);
		jQuery('#navbar').find('li').on('hidden.bs.dropdown', this.updateContentWrap);

		jQuery('body').on('click', 'a.icon.icon-printer', this.handlePrintClick);
		jQuery('body').on('click', 'a.icon.icon-pdf', this.handlePdfClick);

		jQuery('#telephone-cb').on('change', this.handleFormPhone.bind(this));
		jQuery('#letter-cb').on('change', this.handleFormLetter.bind(this));
		jQuery('#info_agreement').on('change', this.handleFormAgreement.bind(this));
		jQuery('#info_agreement2').on('change', this.handleFormAgreement.bind(this));
		jQuery('#info_agreement3').on('change', this.handleFormPhone.bind(this));

		jQuery('#navbar>ul>li').on('mouseenter', this.handleNaviHover);
		jQuery('.dropdown-menu').on('mouseleave', this.handleDropdownMenuMouseout);
		jQuery('#canny-toggle').on('click',this.prepareMobileMenu);
		jQuery('#canny-toggle').on('touchstart',this.prepareMobileMenu);
	},

	updateFormFields: function() {
		this.handleFormLetter(true);
		this.handleFormPhone(true);
	},

	prepareMobileMenu: function() {
		var menu = jQuery('#canny');
		var activeWithSub = menu.find('.canny-parent.active');
		if(activeWithSub.length > 0) {
			activeWithSub.addClass('canny-sub-open');
		}
		var openSubmenu = menu.find('.canny-sub-open');
		if(openSubmenu.length > 0) {
			openSubmenu.find('ul:first').addClass('canny-sub-visible');
		}
	},

	handleNaviHover: function() {
		if(jQuery(this).hasClass('dropdown')) {
			jQuery(this).parent('ul').find('li.dropdown.open').removeClass('open');
			jQuery(this).addClass('open');
		}
	},

	handleDropdownMenuMouseout: function() {
		var parent = jQuery(this).parent('li');
		var navi = parent.parent('ul');
		if(!parent.hasClass('active')) {
			parent.removeClass('open');
			var activeWithSub = navi.find('li.dropdown.active');
			if(activeWithSub.length > 0) {
				activeWithSub.addClass('open');
			}
		}
	},

	updateContentWrap: function() {
		var openSubmenu = jQuery('.dropdown.open');
		if(openSubmenu.length > 0) {
			jQuery('div.content-wrap').addClass('margin-top');
		} else {
			jQuery('div.content-wrap').removeClass('margin-top');
		}
	},

	setZoomLevelFromCookie: function() {
		var cookieLevel = Cookies.get('zoom');
		CC.setZoomLevel(cookieLevel);
	},

	zoomIn: function(e) {
		e.preventDefault();
		var nextZoomLevel = CC.getNextZoomLevel();

		if(nextZoomLevel == null) {
			return;
		}

		CC.setZoomLevel(nextZoomLevel);
		CC.updateZoomButtons();
	},

	zoomOut: function(e) {
		e.preventDefault();
		var previousZoomLevel = CC.getPreviousZoomLevel();

		if(previousZoomLevel == null) {
			return;
		}
		CC.setZoomLevel(previousZoomLevel);
		CC.updateZoomButtons();
	},

	updateZoomButtons: function() {
		var currentZoomLevel = CC.getCurentZoomLevel();

		var possibleZoomLevels =  CC.getPossibleZoomLevels();
		var idx = jQuery.inArray(currentZoomLevel, possibleZoomLevels);

		jQuery('.icon-text-small, .icon-text-big').closest('li').removeClass('inactive');
		if(idx == 0) {
			jQuery('.icon-text-small').closest('li').addClass('inactive');
		} else if (idx == possibleZoomLevels.length-1) {
			jQuery('.icon-text-big').closest('li').addClass('inactive');
		}
	},

	setZoomLevel: function(level) {
		var body = jQuery('body');
		jQuery.each(CC.getPossibleZoomLevels(), function(idx, itm) {
			if(itm != level) {
				body.removeClass('zoom-' + itm);
			}
		});

		body.addClass('zoom-' + level);
		Cookies.set('zoom', level);
	},

	getCurentZoomLevel: function() {
		var body = jQuery('body');
		var currentZoomLevel = 'default';
		jQuery.each(CC.getPossibleZoomLevels(), function(idx, itm) {
			if(body.hasClass('zoom-' + itm)) {
				currentZoomLevel = itm;
			}
		});

		return currentZoomLevel;
	},

	getPossibleZoomLevels: function() {
		return [
			'default',
			'big',
			'bigger'
		];
	},

	getNextZoomLevel: function() {
		var currentZoomLevel = CC.getCurentZoomLevel();
		var possibleZoomLevels = CC.getPossibleZoomLevels();
		var idx = jQuery.inArray(currentZoomLevel, possibleZoomLevels);

		if(possibleZoomLevels[idx+1]) {
			return possibleZoomLevels[idx+1];
		} else {
			return null;
		}
	},

	getPreviousZoomLevel: function() {
		var currentZoomLevel = CC.getCurentZoomLevel();
		var possibleZoomLevels = CC.getPossibleZoomLevels();
		var idx = jQuery.inArray(currentZoomLevel, possibleZoomLevels);

		if(possibleZoomLevels[idx-1]) {
			return possibleZoomLevels[idx-1];
		} else {
			return null;
		}
	},

	handlePrintClick: function(e) {
		e.preventDefault();
		var url = jQuery(this).data('uri');
		window.open(url, '_blank');
	},

	handlePdfClick: function(e) {
		e.preventDefault();
		var url = jQuery(this).data('uri');
		window.open(url, '_blank');
	},

	handleFormPhone: function(noScrolling) {
		if(jQuery('#telephone-cb').is(':checked') || jQuery('#info_agreement3').is(':checked')) {
			jQuery('#contact-by-phone').show();
			if(!noScrolling) {
				jQuery('html, body').animate({ scrollTop: jQuery('#telephone-input').offset().top-jQuery('.navbar').height()-jQuery('.dropdown-menu').height() });
			}
		} else {
			jQuery('#contact-by-phone').hide();
		}
	},

	handleFormAgreement: function(noScrolling) {
		this._triggerAddressField(noScrolling);
	},

	handleFormLetter: function(noScrolling) {
		this._triggerAddressField(noScrolling);
	},

	_triggerAddressField: function(noScrolling) {
		if(jQuery('#info_agreement').is(':checked') || jQuery('#info_agreement2').is(':checked') || jQuery('#letter-cb').is(':checked')) {
			if(!jQuery('.address-field').is(':visible')) {
				jQuery('.address-field').show();
				if(!noScrolling) {
					jQuery('html, body').animate({ scrollTop: jQuery('#street-input').offset().top-jQuery('.navbar').height()-jQuery('.dropdown-menu').height() });
				}
			}
		} else {
			jQuery('.address-field').hide();
		}
	},

	checkForFormErrors: function() {
		if(jQuery('#contact-form.form-error').length) {
			jQuery('html, body').animate({ scrollTop: jQuery('#contact-form .error-message').offset().top-jQuery('.navbar').height()-jQuery('.dropdown-menu').height() });

		}
	}
};
